// Routes du module « conception » : schéma fonctionnel et cheminements d'un dossier d'étude.
import type { RouteObject } from 'react-router';
import '../../styles/conception.css';
import { PageConception } from './PageConception.tsx';
import { PageCatalogueTechnique } from './reglages/PageCatalogueTechnique.tsx';

export const routesConception: RouteObject[] = [
  { path: 'etudes/catalogue-technique', element: <PageCatalogueTechnique /> },
  { path: 'etudes/:id/conception', element: <PageConception /> },
];
